export const REST_API_END_POINTS = {
  AUTHENTICATION: 'authentication',
  SIGN_UP: 'register',
  COMMENTS: 'comments',
  CUSTOMERS: 'customers',
  USERS: 'users',
  DEVICES: 'devices',
  DEVICES_PART_REPORT: 'device_part_reports',
  TOKENS: 'tokens',
  TOKEN_HISTORY: 'tokens_history',
  DELIVERIES: 'deliveries',
  LISTS: 'lists',
  TICKETS: 'tickets',
  SLAS: 'slas',
  ORGANIZATIONS: 'organizations',
  RIGHTS: 'rights',
  VOUCHERS: 'vouchers',
  LOANER_INVENTORY: 'inventory/loaners',
  SERIALIZABLE_INVENTORY: 'inventory/serializables',
  PENALTY: 'inventory/penalty/',
  REPAIR_INVENTORY: 'inventory/repairs',
  LOANER_RECORDS: 'loanerrecords',
  ORDER_LINES: 'orderlines',
  SERIALIZABLE_ORDER_LINE: 'serializable_orderlines',
  GSX: 'gsx',
  GSX_INFO: 'gsx_info',
  REPORTS: 'reports',
  COMPONENT_ISSUE: 'component_issues',
  PART_REQUEST: 'part_requests',
  UPLOADS: 'uploads',
  DOWNLOADS: 'downloads',
  QNA: 'qna',
  DEMO_REQUESTS:'demo_requests',
  WEB_HOOKS:'webhooks',
  QUOTATION_RECORD:"quotationrecords",
  BUYBACK_EMI_RECORD:"buyback_emi_records",
  SUPPORT_PACKAGES:"support_packages"
}
